import { render } from "./weblinkUserSyncTask.vue?vue&type=template&id=7fbcd3e2&ts=true"
import script from "./weblinkUserSyncTask.vue?vue&type=script&lang=ts"
export * from "./weblinkUserSyncTask.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\development\\source\\repositories\\Koncepta\\Core.Services\\Core.WebApp\\admin-ui\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__